import styled from 'styled-components'

export default styled.div`
  width: 100vw;
  height: 52px;
  position: fixed;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid #ececec;
  background-color: #fff;

  .navbar {
    padding: 0 10px;
    height: 52px;
  }

  .navbar-brand {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 120px;

    img {
      width: 100%;
    }
  }

  .navbar-toggler {
    border: none;
    outline: none;
    padding: 3px;
  }

  .navbar-toggler-icon {
    width: 16px;
    color: #000;
  }

  .header-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &.hidden {
      display: none;
    }

    &--menu {
      left: 20px;
    }

    &--search {
      left: 55px;
    }

    &--qr {
      right: 55px;

      &:not(.dot) {
        opacity: 0.3;
      }
    }

    &--cart {
      right: 20px;
    }

    &.dot::after {
      content: '';
      height: 4px;
      width: 4px;
      background-color: #000;
      border-radius: 50%;
      display: block;
      position: absolute;
      top: 0px;
      right: -5px;
    }
  }

  .fade-search-bar-enter {
    opacity: 0.01;
  }

  .fade-search-bar-enter.fade-search-bar-enter-active {
    opacity: 1;
    transition: opacity 500ms ease-in;
  }

  .fade-search-bar-exit {
    opacity: 1;
  }

  .fade-search-bar-exit.fade-search-bar-exit-active {
    opacity: 0.01;
    transition: opacity 300ms ease-in;
  }
`



// WEBPACK FOOTER //
// ./src/styles/HeaderBar.js